<template>
  <mdb-container>
    <div v-if="currentGroup">
      <banner-small :group="currentGroup" title="Event Galleries"/>
      <mdb-card v-if="galleries.length==0">
        <mdb-card-body>
          {{currentGroup.name}} doesn't have any event galleries yet. To create a gallery, simply click the "Event Gallery" button
          from any event.
        </mdb-card-body>

      </mdb-card>
    </div>

    <mdb-row v-if="galleries.length > 0">
      <div :id="'image-'+i" :key="i" class="col-md-3 d-flex align-self-stretch" v-for="(event,i) in galleries">
        <mdb-card class="face front mb-4 animated rotateIn">
          <mdb-card-header>
            <h5 class=" card-header-truncated">{{event.title}}</h5>
          </mdb-card-header>
          <mdb-view hover zoom>
            <a @click.prevent="showGallery(event)" href="">
              <mdb-card-image
                :src="event.cover"
                alt="Card image cap"
              ></mdb-card-image>
              <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
            </a>
          </mdb-view>
          <mdb-card-body>
            <div>
              <p>{{event.date}}</p>
              <small>{{event.images}} image{{event.images > 1 ? 's' :''}}</small>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>
    </mdb-row>
    <div v-if="galleries.length < totalGalleries">
      <mdb-btn icon="circle-plus" @click="loadMore">Load More</mdb-btn>
    </div>


  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import bannerSmall from '../group/BannerSmall'
import {mapState} from 'vuex'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbContainer,
  mdbIcon,
  mdbMask,
  mdbRow,
  mdbView
} from 'mdbvue';

export default {
    name: "group-events",
    components: {
      mdbBtn,
      mdbContainer,
      mdbIcon,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbView, mdbRow, mdbMask, mdbCardImage,
      bannerSmall,
    },
    computed: mapState({
                         currentGroup: state => state.currentGroup
                       }),
    data() {
      return {
        galleries: [],
        totalGalleries: [],
        offset: 0,
        maxPer: 25
      }
    },
    mounted() {
      document.title = "Event Galleries"
      this.loadGalleries()
    },
    methods: {
      loadMore() {
        this.offset+=this.maxPer
        this.loadGalleries()
      },
      loadGalleries() {
        this.$store.dispatch("setExecuting", true)
        api.get("/group/galleries/" + this.$route.params.id + "/?offset=" + this.offset + "&max=" + this.maxPer).then(
          (results) => {
            if (this.offset == 0) {
              this.galleries = results.data.galleries
              this.totalGalleries = results.data.totalCount
            }
            else {
              for (let i=0; i<results.data.galleries.length; i++) {
                this.galleries.push(results.data.galleries[i])
              }
            }
            if (!this.currentGroup || this.currentGroup.id != results.data.groupId) {
              api.groupBasics(results.data.groupId, "member");
            }
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
        api.trackGroupVisit(this.$route.params.id)
      },
      showGallery(g) {
        this.$router.push("/event/gallery/"+ g.id)
      }
    }
  };

</script>
